<script>
import axios from "axios";

import {
  authMethods,
  authFackMethods,
  notificationMethods,
  oauth2Methods
} from "@/state/helpers";
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import { mapState } from "vuex";

import { required, email } from "vuelidate/lib/validators";

import InputPassword from "@/components/inputs/password"

/**
 * Register component
 */
export default {
  page: {
    title: "Register",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    InputPassword,
  },
  data() {
    return {
      user: {
        username: "",
        email: "",
        password: "",
      },
      model: {},
      submitted: false,
      regError: null,
      tryingToRegister: false,
      isRegisterError: false,
      registerSuccess: false,

      oauth2Type: 'password',
    };
  },
  validations: {
    user: {
      username: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
      },
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...(process.env.VUE_APP_DEFAULT_AUTH === "oauth2" ? oauth2Methods : authFackMethods),
    ...notificationMethods,
    // Try to register the user in with the email, username
    // and password they provided.
    async tryToRegisterIn() {
      this.submitted = true;
      // stop here if form is invalid
      const invalid = !(await this.$refs.form.validate());

      if (invalid) {
        return;
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          this.tryingToRegister = true;
          // Reset the regError if it existed.
          this.regError = null;
          return (
            this.register({
              email: this.user.email,
              password: this.user.password,
            })
              // eslint-disable-next-line no-unused-vars
              .then((token) => {
                this.tryingToRegister = false;
                this.isRegisterError = false;
                this.registerSuccess = true;
                if (this.registerSuccess) {
                  this.$router.push(
                    this.$route.query.redirectFrom || {
                      name: "default",
                    }
                  );
                }
              })
              .catch((error) => {
                this.tryingToRegister = false;
                this.regError = error ? error : "";
                this.isRegisterError = true;
              })
          );
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
          const { email, username, password } = this.user;
          if (email && username && password) {
            this.registeruser(this.user);
          }
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "authapi") {
          axios
            .post("http://127.0.0.1:8000/api/register", {
              username: this.user.username,
              email: this.user.email,
              password: this.user.password,
            })
            .then((res) => {
              return res;
            });
        } else if (process.env.VUE_APP_DEFAULT_AUTH === "oauth2") {
          if (this.oauth2Type !== 'password') {
            const url = new URL(`${process.env.VUE_APP_OAUTH2_BASE_URL}/authorize`);
            const searchParams = new URLSearchParams()
            searchParams.set('client_id', process.env.VUE_APP_OAUTH2_CLIENT_ID);
            searchParams.set('redirect_uri', `${window.location.origin}/login`);
            searchParams.set('response_type', 'token');
            searchParams.set('scope', '*');
            url.search = searchParams.toString();
            window.location.href = url.toString();
          } else {
            this.tryingToRegister = true;
            // Reset the authError if it existed.
            this.regError = null;
            this.isRegisterError = false;

            let body = this.lodash.cloneDeep(this.model);
            delete body.password_old;

            this.oauth2Register({
              ...body,
              redirect: `${window.location.origin}/verify_email/success`
            })
            .then((response) => {
              this.tryingToRegister = false;
              this.isRegisterError = false;
              return response;
            })
            .catch((error) => {
              this.tryingToRegister = false;
              if (error.response && error.response.data && error.response.data.message)
                this.regError = this.$t(error.response.data.message) || "";
              else
                this.regError = error ? error : "";

              if (error.response.status === 422){
                if (error.response.data.errors.email){
                  let emailInvalid = error.response.data.errors.email.includes(this.$t('register.not_valid_error_message', 'en', {attribute: 'email'}))
                  emailInvalid = emailInvalid || error.response.data.errors.email.includes(this.$t('register.not_valid_error_message', 'id', {attribute: 'email'}))
                  if (emailInvalid){
                    error.response.data.errors.email = [this.$t('validation.is_not', {_field_: this.lodash.startCase(this.$t('users.email')), _value_: this.model.email})]
                  }
                }
                this.$refs.form.setErrors(error.response.data.errors);
              }
              this.isRegisterError = true;
            });
          }
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft border-bottom">
            <div class="row">
              <div class="col-7">
                <div class="p-4">
                  <h5>{{ lodash.startCase($t('register.welcome')) }}</h5>
                  <p>Get your free Skote account now.</p>
                </div>
              </div>
              <div class="col-5 align-self-center">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
<!--            <div>-->
<!--              <router-link tag="a" to="/">-->
<!--                <div class="avatar-md profile-user-wid mb-4">-->
<!--                  <span class="avatar-title rounded-circle bg-light">-->
<!--                    <img-->
<!--                      src="@/assets/images/logo.svg"-->
<!--                      alt-->
<!--                      class="rounded-circle"-->
<!--                      height="34"-->
<!--                    />-->
<!--                  </span>-->
<!--                </div>-->
<!--              </router-link>-->
<!--            </div>-->

            <b-alert
              v-model="registerSuccess"
              class="mt-3"
              variant="success"
              dismissible
              >Registration successfull.</b-alert
            >

            <b-alert
              v-model="isRegisterError"
              class="mt-3"
              variant="danger"
              dismissible
              >{{ regError }}</b-alert
            >

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToRegisterIn">
              <validation-observer tag="div" ref="form">
                <validation-provider vid="name" :name="lodash.startCase($t('users.name'))" rules="required" v-slot="{ valid, errors }">
                  <b-form-group
                      class="row mb-3"
                      label-class="fw-bold"
                      :label="lodash.startCase($t('users.name'))"
                      label-for="name"
                      :state="errors[0] ? false : (valid ? true : null)"
                      :invalid-feedback="errors[0]"
                  >
                    <b-form-input
                        for="name"
                        name="name"
                        type="text"
                        required
                        :state="errors[0] ? false : (valid ? true : null)"
                        v-model="model.name"
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
                <validation-provider vid="email" :name="lodash.startCase($t('users.email'))" rules="required|email" v-slot="{ valid, errors }">
                  <b-form-group
                      class="row mb-3"
                      label-class="fw-bold"
                      :label="lodash.startCase($t('users.email'))"
                      label-for="email"
                      :state="errors[0] ? false : (valid ? true : null)"
                      :invalid-feedback="errors[0]"
                  >
                    <b-form-input
                        for="email"
                        name="email"
                        type="email"
                        required
                        :state="errors[0] ? false : (valid ? true : null)"
                        v-model="model.email"
                    ></b-form-input>
                  </b-form-group>
                </validation-provider>
                <template>
                  <validation-provider vid="password" :name="lodash.startCase($t('users.password'))" :rules="{required: !model.id, password_format: true}" v-slot="{ valid, errors }">
                    <b-form-group
                        class="row mb-3"
                        label-class="fw-bold"
                        :label="lodash.startCase($t('users.password'))"
                        label-for="password"
                        :state="errors[0] ? false : (!model.id && valid ? true : null)"
                        :invalid-feedback="errors[0]"
                    >
                      <input-password
                          for="password"
                          name="password"
                          required
                          :state="errors[0] ? false : (!model.id && valid ? true : null)"
                          v-model="model.password"
                      ></input-password>
                    </b-form-group>
                  </validation-provider>
                  <validation-provider vid="password_confirmation" :name="lodash.startCase($t('users.password_confirmation'))" :rules="model.password ? 'required|confirmed:password' : undefined" v-slot="{ valid, errors }">
                    <b-form-group
                        class="row mb-3"
                        label-class="fw-bold"
                        :label="lodash.startCase($t('users.password_confirmation'))"
                        label-for="password_confirmation"
                        :state="errors[0] ? false : (model.password && valid ? true : null)"
                        :invalid-feedback="errors[0]"
                    >
                      <input-password
                          for="password_confirmation"
                          name="password_confirmation"
                          required
                          :state="errors[0] ? false : (model.password && valid ? true : null)"
                          v-model="model.password_confirmation"
                      ></input-password>
                    </b-form-group>
                  </validation-provider>
                </template>
              </validation-observer>

              <div class="mt-4 d-grid">
                <b-button type="submit" variant="primary" class="btn-block" :disabled="tryingToRegister"
                  >{{ lodash.startCase($t('register.register')) }}</b-button
                >
              </div>

<!--              <div class="mt-4 text-center">-->
<!--                <h5 class="font-size-14 mb-3">Sign up using</h5>-->

<!--                <ul class="list-inline">-->
<!--                  <li class="list-inline-item">-->
<!--                    <a-->
<!--                      href="javascript: void(0);"-->
<!--                      class="social-list-item bg-primary text-white border-primary"-->
<!--                    >-->
<!--                      <i class="mdi mdi-facebook"></i>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                  <li class="list-inline-item">-->
<!--                    <a-->
<!--                      href="javascript: void(0);"-->
<!--                      class="social-list-item bg-info text-white border-info"-->
<!--                    >-->
<!--                      <i class="mdi mdi-twitter"></i>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                  <li class="list-inline-item">-->
<!--                    <a-->
<!--                      href="javascript: void(0);"-->
<!--                      class="social-list-item bg-danger text-white border-danger"-->
<!--                    >-->
<!--                      <i class="mdi mdi-google"></i>-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->

<!--              <div class="mt-4 text-center">-->
<!--                <p class="mb-0">-->
<!--                  By registering you agree to the Skote-->
<!--                  <a href="javascript: void(0);" class="text-primary"-->
<!--                    >Terms of Use</a-->
<!--                  >-->
<!--                </p>-->
<!--              </div>-->
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            {{ lodash.upperFirst($t('register.already_have_account')) }}
            <router-link
                tag="a"
                to="/login"
                class="fw-medium text-primary"
              >{{ lodash.startCase($t('register.login')) }}</router-link
            >
          </p>
          <p>
            © {{ new Date().getFullYear() }} Skote. Crafted with
            <i class="mdi mdi-heart text-danger"></i> by Themesbrand
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
